import { PropsWithChildren, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./side-modal.scss";

interface ModalProps {
  id?: string;
  title?: string;
  loading?: boolean;
  containerClass?: string;
  size?: "xl" | "large" | "medium";
  onClose?: () => void;
  isChanged?: boolean;
}

export default function SideModal(props: PropsWithChildren<ModalProps>) {
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    document.body.style.overflow = "hidden";

    //@ts-ignore
    window.closeModal = props.onClose;
    return () => {
      //@ts-ignore
      window.closeModal = props.onClose;
      document.body.style.overflow = "initial";
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      if (modalRef.current) modalRef.current.style.opacity = "1";
    }, 100);

    window.onkeydown = onCloseListener;
  }, [props.isChanged]);

  function onCloseListener(e: KeyboardEvent) {
    if (e.keyCode === 27) {
      handleClose();
    }
  }

  function handleClose() {
    if (!props.isChanged) {
      closeAction();
      return;
    }
    // store.dispatch(
    //   setDialogModal({
    //     icon: "bi bi-floppy",
    //     title: "Değişilikleri Kaydet",
    //     message:
    //       "Kaydedilmemiş değişiklikleriniz mevcut. Kapatmak istediğinize emin misiniz?",
    //     button: {
    //       text: "Kapat",
    //       onClick: closeAction,
    //     },
    //     cancel: {
    //       text: "Vazgeç",
    //     },
    //   })
    // );
  }

  function closeAction() {
    if (modalRef.current) {
      modalRef.current.style.opacity = "0";
      modalRef.current.style.display = "none";
    }

    setTimeout(() => {
      window.onkeydown = null;
      if (props.onClose) props.onClose();
    }, 0);
  }

  function handleCloseByClick(event: any) {
    if (
      typeof event.target?.className === "string" &&
      event.target?.className?.includes("sidebar-popup")
    ) {
      handleClose();
    }
  }

  return (
    <div
      ref={modalRef}
      className={"toggle-popup sidebar-popup " + (props.containerClass || "")}
      onClick={handleCloseByClick}
    >
      <div className={`sidebar-layout ${props.size || "large"}-layout`}>
        <div
          className="sidebar-header"
          style={{ height: "60px" }}
        >
          <h4>{props.title}</h4>
          <Link
            to="#"
            className="sidebar-close toggle-btn"
            onClick={handleClose}
          >
            &times;
          </Link>
        </div>

        <div
          className="toggle-body"
          style={{
            overflowY: "scroll",
            overflowX: "hidden",
            height: "calc(100vh - 60px)",
          }}
        >
          {props.loading ? <Loader /> : props.children}
        </div>
      </div>
    </div>
  );
}

function Loader() {
  return (
    <div className="w-100 h-100 d-flex justify-content-center align-items-center">
      <div
        className="spinner-border text-primary"
        style={{ width: "3rem", height: "3rem" }}
        role="status"
      ></div>
    </div>
  );
}
